import React, { useCallback, useEffect, useState } from 'react';
import { Table, Button, Popconfirm, message, Typography, Tabs } from 'antd';
import moment from 'moment';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import _ from 'lodash';
import {
    getTreatmentNotes,
    confirmTreatmentNote,
    unconfirmTreatmentNote,
    removeTreatmentNotes,
    getTreatmentNoteDetail
} from '@/redux/actions/treatmentNoteActions';
import { useDispatch, useSelector } from 'react-redux';
import { cleanObject } from '@/utils/helpers';
import NoteForm from './appointment/NoteForm';
import { getSpecificCustomer } from "@/redux/actions/customerActions";
import { CheckOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { TabPane } = Tabs;

const TreatmentNoteStatistics = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState('pending');
    const [isOpenFormNote, setIsOpenFormNote] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [currentNote, setCurrentNote] = useState(null);

    const items = useSelector(state => state.treatmentNoteReducer.list.items);
    const pagination = useSelector(state => state.treatmentNoteReducer.list.pagination);
    const authUser = useSelector(state => state.auth.authUser);

    const query = qs.parse(location.search.slice(1));

    const loadData = useCallback((q = query) => {
        setLoading(true);
        dispatch(getTreatmentNotes(q)).finally(() => setLoading(false));
    }, [dispatch, query]);

    useEffect(() => {
        loadData();
    }, [location.search]);

    useEffect(() => {
        if (query.note_status) {
            setActiveTabKey(query.note_status);
        } else {
            setActiveTabKey('pending'); // fallback nếu không có query
        }
    }, [query.note_status]);

    const handleChangeTable = (pagination, sorter) => {
        let q = { ...query };
        if (!_.isEmpty(pagination)) {
            q.page = pagination.current;
            q.per_page = pagination.pageSize;
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                q.sort_field = sorter.field;
                q.sort_type = sorter.order === 'ascend' ? 'ASC' : 'DESC';
            } else {
                delete q.sort_field;
                delete q.sort_type;
            }
        }
        history.push({ pathname: location.pathname, search: qs.stringify(q) });
    };

    const handleFilterChange = (name, value) => {
        let q = { ...query, [name]: value };
        q = cleanObject(q);
        history.push({ pathname: location.pathname, search: qs.stringify(q) });
    };

    const handleConfirm = async (id) => {
        await dispatch(confirmTreatmentNote(id));
        message.success('Đã xác nhận!');
        setSelectedRowKeys([]);
        loadData();
    };

    const handleUnconfirm = async (id) => {
        await dispatch(unconfirmTreatmentNote(id));
        message.success('Đã hủy xác nhận!');
        loadData();
    };

    const handleDelete = async (id) => {
        await dispatch(removeTreatmentNotes([id]));
        message.success('Đã xóa!');
        loadData();
    };

    const handleTabChange = (key) => {
        setActiveTabKey(key);
        handleFilterChange('note_status', key);
    };

    const handleEdit = async (isOpenFormNote, id) => {
        try {
            const res = await dispatch(getTreatmentNoteDetail(id)); // action creator từ redux
            const res2 = await dispatch(getSpecificCustomer(res.customer_id));
            setCurrentItem(res2);
            setCurrentNote(res);
            setIsOpenFormNote(isOpenFormNote);
        } catch (err) {
            message.error('Không thể lấy dữ liệu ghi chú');
        }
    };

    const onCancelFormNote = () => {
        setIsOpenFormNote(false);
        setCurrentItem(null);
        setCurrentNote(null);
    };


    const columnsPending = [
        {
            title: 'Khách hàng',
            dataIndex: 'customer',
            width: 150,
            render: (text, record) => record?.customer?.full_name
        },
        {
            title: 'Hành động',
            align: 'center',
            width: '180px',
            render: (_, record) => {
                const isAssistant = authUser.role_code === 'PHUTA';
                const isConfirmed = !!record.confirmed_by;

                // Điều kiện cập nhật
                const canUpdate = (record.is_doctor_in_customer || record.is_owned_by_me)
                    && !(isAssistant && isConfirmed);

                // Điều kiện xóa
                const canDelete = record.is_owned_by_me && !(isAssistant && isConfirmed);

                return (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                        <Button
                            type="default"
                            size="small"
                            disabled={!canUpdate}
                            onClick={() => handleEdit(true, record.id)}
                        >
                            Cập nhật
                        </Button>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
                            {activeTabKey === 'pending' && (
                                <Popconfirm
                                    //disabled={!record.is_doctor_in_customer}
                                    title="Xác nhận ghi chú này?"
                                    onConfirm={() => handleConfirm([record.id])}
                                >
                                    <Button
                                        //disabled={!record.is_doctor_in_customer}
                                        size="small"
                                        type="primary"
                                    >
                                        Xác nhận
                                    </Button>
                                </Popconfirm>
                            )}

                            {activeTabKey === 'confirmed' && (
                                <Popconfirm
                                    disabled={!record.is_confirmed_by_me}
                                    title="Hủy xác nhận?"
                                    onConfirm={() => handleUnconfirm(record.id)}
                                >
                                    <Button
                                        disabled={!record.is_confirmed_by_me}
                                        size="small"
                                        danger
                                    >
                                        Hủy xác nhận
                                    </Button>
                                </Popconfirm>
                            )}

                            <Popconfirm
                                disabled={!canDelete}
                                title="Xóa ghi chú này?"
                                onConfirm={() => handleDelete(record.id)}
                            >
                                <Button
                                    disabled={!canDelete}
                                    size="small"
                                    type="link"
                                    danger
                                >
                                    Xóa
                                </Button>
                            </Popconfirm>
                        </div>
                    </div>
                );
            }
        },
        {
            title: 'Nội dung',
            dataIndex: 'content',
            width: '350px',
            render: text => <div dangerouslySetInnerHTML={{ __html: text }} />,
        },


        {
            title: 'Người nhập',
            dataIndex: 'created_by',
            width: 150,
            render: (text, record) => record?.created_by?.full_name
        },
        ...(activeTabKey === 'confirmed' ? [{
            title: 'Bác sĩ xác nhận',
            dataIndex: 'confirmed_by',
            width: 150,
            render: (text, record) => record?.confirmed_by?.full_name
        }] : []),
        {
            title: 'Ngày tạo',
            dataIndex: 'created_at',
            width: 100,
            render: text => moment(text).format('DD/MM/YYYY HH:mm')
        }
    ];

    const table = <Table
        rowKey="id"
        size="small"
        tableLayout='auto'
        dataSource={items || []}
        columns={columnsPending}
        loading={loading}
        rowSelection={{ selectedRowKeys, onChange: setSelectedRowKeys }}
        pagination={{
            pageSize: pagination.perPage,
            current: pagination.currentPage,
            total: pagination.total,
            showTotal: total => `Tổng ${total} bản ghi`
        }}
        onChange={(pagination, filter, sorter) => handleChangeTable(pagination, sorter)}
        scroll={{
            x: 'max-content'
        }}
    />

    return (
        <div>
            <Title level={4} className='mt-4'>Thống kê ghi chú điều trị</Title>

            <Tabs
                activeKey={activeTabKey}
                onChange={(key) => handleTabChange(key)}
            >
                <TabPane tab="Ghi chú chưa xác nhận" key="pending">
                    <div className="mb-3">
                        <Popconfirm
                            disabled={!selectedRowKeys.length}
                            title="Xác nhận các bản ghi đã chọn?"
                            onConfirm={() => handleConfirm(selectedRowKeys)}
                        >
                            <Button
                                type="primary"
                                size="small"
                                icon={<CheckOutlined />}
                                disabled={!selectedRowKeys.length}
                            >Xác nhân</Button>
                        </Popconfirm>
                    </div>
                    {table}
                </TabPane>

                <TabPane tab="Ghi chú đã xác nhận" key="confirmed">
                    {table}
                </TabPane>
            </Tabs>

            <NoteForm
                visible={isOpenFormNote}
                currentItem={currentItem}
                currentNote={currentNote}
                onCancel={() => onCancelFormNote()}
            />
        </div>
    );
};

export default TreatmentNoteStatistics;
